import { isEmpty, startCase } from 'lodash'

import { APP_ENV, ORG_NAME } from 'utils/env'
import { DAYS_OF_WEEK, MENU_MODEL_DESCRIPTIONS } from 'resources'

export const getSortedConfigurationModels = (configurationModels) => {
  const configurationModelsOrder = {
    '[POS QS]': 1,
    '[POS FS]': 2,
    '[Kiosk]': 3,
    '[Mobile]': 4,
    '[Autonomous]': 5,
  }

  return configurationModels?.sort((a, b) => {
    const configurationModelNameRegExp = /(\[.*?\])?\s*(.*)/

    const aOrder =
      configurationModelsOrder[
        a.name.match(configurationModelNameRegExp)[1]
      ] ?? configurationModelsOrder.length

    const bOrder =
      configurationModelsOrder[
        b.name.match(configurationModelNameRegExp)[1]
      ] ?? configurationModelsOrder.length

    return aOrder - bOrder
  })
}

export const getDisplayConfigurationModelName = (name = '') => {
  const configurationModelName = name.match(/(\[.*?\])?\s*(.*)/)
  const serviceType = configurationModelName?.[1] ?? ''
  const displayName = configurationModelName?.[2] ?? ''

  return (
    <div>
      <span className="font-weight-bold">{serviceType}</span>{' '}
      {displayName}
    </div>
  )
}

export const getPickupForConcessions = (serviceTypeName) => {
  if (isEmpty(serviceTypeName)) return ''

  return serviceTypeName === 'Concessions'
    ? 'Pickup'
    : serviceTypeName
}

export const getDisplayMenuName = (menu) => {
  const name = !isEmpty(menu?.configurationModelName)
    ? menu?.configurationModelName
    : startCase(getPickupForConcessions(menu?.serviceType))

  const displayName = !isEmpty(menu?.displayName)
    ? menu?.displayName
    : menu?.name

  return { name, displayName }
}

export const createRevenueCenterImageUrl = (standUuid) => {
  const orgName = ORG_NAME
  const env = APP_ENV
  const timeStamp = new Date().valueOf()

  return `https://d2bekohrrq5iy7.cloudfront.net/${orgName}/${env}/stands-tout-${standUuid}.webp?${timeStamp}`
}

export const sortDays = (days) => {
  return Object.fromEntries(
    Object.entries(days).sort((a, b) => {
      return DAYS_OF_WEEK.indexOf(a[0]) - DAYS_OF_WEEK.indexOf(b[0])
    })
  )
}

export const getMenuModelDescription = (
  isNew,
  configurationModelId
) => {
  switch (true) {
    case isNew:
      return MENU_MODEL_DESCRIPTIONS.newMenu

    case isEmpty(configurationModelId):
      return MENU_MODEL_DESCRIPTIONS.emptyConfigurationId

    case !isEmpty(configurationModelId):
      return MENU_MODEL_DESCRIPTIONS.filledConfigurationId

    default:
      return MENU_MODEL_DESCRIPTIONS.emptyConfigurationId
  }
}

/*
 * checkMenuPrefix check the prefix passed as a string or an array from the menu model name or serviceType name
 * @param {string} menu model name | serviceType name
 * @param {string | array} prefix - name of the prefix or array of prefixes
 */

export const checkMenuPrefix = (name, prefix) => {
  if (isEmpty(name) || isEmpty(prefix)) return false

  const menuPrefix = !!name.match(/(\[.*?\])?\s*(.*)/)[1]
    ? name.match(/(\[.*?\])?\s*(.*)/)[1]
    : name

  switch (true) {
    case typeof prefix === 'string':
      return menuPrefix?.toLowerCase().includes(prefix.toLowerCase())

    case Array.isArray(prefix):
      return prefix.some((_prefix) =>
        menuPrefix?.toLowerCase().includes(_prefix.toLowerCase())
      )

    default:
      return false
  }
}

export const hasMenuEmptyMerchantId = (name, merchantId) => {
  const isKioskOrPos = checkMenuPrefix(name, ['kiosk', 'pos'])

  return isKioskOrPos && isEmpty(merchantId)
}

export const getMenuUuidsForEmptyMerchantId = (menus) => {
  return menus
    ?.filter((menu) => {
      const { name } = getDisplayMenuName(menu)

      const isKioskOrPos = checkMenuPrefix(name, ['kiosk', 'pos'])

      return isKioskOrPos && isEmpty(menu?.merchantId)
    })
    .map((menu) => menu.uuid)
}

export const revenueCenterContainsMobileMenus = (revenueCenter) => {
  const mobileServiceTypes = [
    'Concessions',
    'Delivery',
    'SelfCheckout',
    'QuickPay',
  ]

  return revenueCenter?.some((menu) =>
    mobileServiceTypes.includes(menu.serviceType)
  )
}

export const isMobileMenu = (serviceType) => {
  const mobileServiceTypes = [
    'Concessions',
    'Delivery',
    'SelfCheckout',
    'QuickPay',
  ]

  return mobileServiceTypes.includes(serviceType)
}
